// GETOLO Domains
export const DOMAIN_DENTOLO_DE = 'dentolo.de';
export const DOMAIN_PETOLO_DE = 'petolo.de';
export const DOMAIN_VITOLO_DE = 'vitolo.de';
export const DOMAIN_PATOLO_FR = 'patolo.fr';

export const DOMAINS_DENTOLO = [DOMAIN_DENTOLO_DE];
export const DOMAINS_PETOLO = [DOMAIN_PETOLO_DE, DOMAIN_PATOLO_FR];
export const DOMAINS_VITOLO = [DOMAIN_VITOLO_DE];
